if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-undef
  window.applicationVersion = { tag: '6.35.0' }
}
